import { HeroMinimal } from "../components/sections";

function TermsPage() {
  const lastUpdated = new Date().toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  return (
    <>
      <HeroMinimal
        title="Terms of Service"
        subtitle={`Last updated: ${lastUpdated}`}
        ctaText="Back to Home"
        ctaHref="/"
      />

      <section className="section" aria-labelledby="terms-content">
        <div className="container">
          <div className="max-w-3xl mx-auto space-y-12">
            <article>
              <h2 id="agreement" className="h2 text-text-primary mb-4">
                Agreement to Terms
              </h2>
              <p className="body text-text-secondary mb-6">
                By accessing and using the UniqReach website ("Website") and
                services ("Services"), you agree to be bound by these Terms of
                Service ("Terms"). If you do not agree to these Terms, please do
                not use the Website or Services.
              </p>
            </article>

            <article>
              <h2 id="services" className="h2 text-text-primary mb-4">
                Description of Services
              </h2>
              <p className="body text-text-secondary mb-4">
                UniqReach provides AI-powered outbound sales systems for B2B
                technology companies. Our Services include strategy consulting,
                system design, data services, automation implementation,
                infrastructure setup, and ongoing optimization. Specific
                deliverables are defined in individual engagement agreements.
              </p>
              <p className="body text-text-secondary mb-4">
                We do not guarantee specific outcomes such as number of
                meetings, pipeline value, reply rates, or revenue. Results vary
                based on market conditions, product-market fit, sales execution,
                and other factors outside our control.
              </p>
            </article>

            <article>
              <h2 id="engagement" className="h2 text-text-primary mb-4">
                Engagement Terms
              </h2>
              <p className="body text-text-secondary mb-4">
                Commercial engagements are governed by separate Master Services
                Agreements (MSAs) or Statements of Work (SOWs) that define
                scope, timelines, fees, intellectual property, confidentiality,
                and liability terms. These Terms apply to website usage and
                pre-engagement interactions.
              </p>
            </article>

            <article>
              <h2
                id="intellectual-property"
                className="h2 text-text-primary mb-4"
              >
                Intellectual Property
              </h2>
              <p className="body text-text-secondary mb-4">
                All content on this Website, including text, graphics, logos,
                images, software, and designs, is the property of UniqReach or
                its licensors and is protected by copyright, trademark, and
                other intellectual property laws.
              </p>
              <p className="body text-text-secondary mb-4">
                You may not reproduce, distribute, modify, create derivative
                works, publicly display, or commercially exploit any content
                without our prior written consent.
              </p>
            </article>

            <article>
              <h2 id="user-conduct" className="h2 text-text-primary mb-4">
                User Conduct
              </h2>
              <p className="body text-text-secondary mb-4">
                When using the Website, you agree not to:
              </p>
              <ul className="list-disc list-inside space-y-2 text-text-secondary mb-6">
                <li>Violate any applicable law or regulation</li>
                <li>Infringe intellectual property rights</li>
                <li>Transmit harmful code or malware</li>
                <li>Attempt unauthorized access to systems</li>
                <li>Scrape or harvest data without permission</li>
                <li>Impersonate any person or entity</li>
                <li>Use the Website for spam, fraud, or abuse</li>
              </ul>
            </article>

            <article>
              <h2 id="disclaimers" className="h2 text-text-primary mb-4">
                Disclaimers
              </h2>
              <p className="body text-text-secondary mb-4">
                The Website and Services are provided "as is" and "as available"
                without warranties of any kind, either express or implied,
                including but not limited to implied warranties of
                merchantability, fitness for a particular purpose, or
                non-infringement.
              </p>
              <p className="body text-text-secondary mb-4">
                We do not warrant that the Website will be uninterrupted,
                error-free, or free of viruses. We do not warrant the accuracy,
                completeness, or timeliness of any content.
              </p>
            </article>

            <article>
              <h2
                id="limitation-of-liability"
                className="h2 text-text-primary mb-4"
              >
                Limitation of Liability
              </h2>
              <p className="body text-text-secondary mb-4">
                To the maximum extent permitted by law, UniqReach shall not be
                liable for any indirect, incidental, special, consequential, or
                punitive damages, including loss of profits, data, use,
                goodwill, or other intangible losses, resulting from your use of
                the Website or Services.
              </p>
              <p className="body text-text-secondary mb-4">
                Our total liability for any claims arising from these Terms
                shall not exceed the fees paid by you in the twelve months
                preceding the claim, or $100 if no fees were paid.
              </p>
            </article>

            <article>
              <h2 id="indemnification" className="h2 text-text-primary mb-4">
                Indemnification
              </h2>
              <p className="body text-text-secondary mb-4">
                You agree to indemnify, defend, and hold harmless UniqReach and
                its officers, directors, employees, and agents from and against
                any claims, damages, obligations, losses, liabilities, costs,
                and expenses (including attorney's fees) arising from your use
                of the Website, violation of these Terms, or infringement of any
                third-party rights.
              </p>
            </article>

            <article>
              <h2 id="termination" className="h2 text-text-primary mb-4">
                Termination
              </h2>
              <p className="body text-text-secondary mb-4">
                We may terminate or suspend your access to the Website
                immediately, without prior notice, for any reason including
                breach of these Terms. Upon termination, your right to use the
                Website ceases immediately.
              </p>
            </article>

            <article>
              <h2 id="governing-law" className="h2 text-text-primary mb-4">
                Governing Law
              </h2>
              <p className="body text-text-secondary mb-4">
                These Terms shall be governed by and construed in accordance
                with the laws of the State of Delaware, United States, without
                regard to conflict of law principles. Any disputes shall be
                resolved in the state and federal courts located in Delaware.
              </p>
            </article>

            <article>
              <h2 id="changes" className="h2 text-text-primary mb-4">
                Changes to Terms
              </h2>
              <p className="body text-text-secondary mb-4">
                We reserve the right to modify these Terms at any time. Changes
                will be effective immediately upon posting to this page with an
                updated "Last Updated" date. Your continued use of the Website
                constitutes acceptance of the modified Terms.
              </p>
            </article>

            <article>
              <h2 id="contact-terms" className="h2 text-text-primary mb-4">
                Contact Us
              </h2>
              <p className="body text-text-secondary mb-4">
                If you have questions about these Terms, please contact us:
              </p>
              <address className="not-italic text-text-secondary">
                <p>UniqReach</p>
                <p>Email: hello@uniqreach.com</p>
                <p>United States</p>
              </address>
            </article>
          </div>
        </div>
      </section>
    </>
  );
}

export default TermsPage;
